var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31.1",
    style: {
      enableBackground: "new 0 0 31 31.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#020203;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 21,
    className: "st0",
    width: 2.7,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 16.9,
    className: "st0",
    width: 2.7,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7,
    y: 12.8,
    className: "st0",
    width: 2.7,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.4,4.6h-4.1V1.9H8.7v2.7H4.6C3.8,4.6,3.2,5.2,3.2,6v21.8c0,0.7,0.6,1.4,1.4,1.4h21.8c0.7,0,1.4-0.6,1.4-1.4 V6C27.8,5.2,27.2,4.6,26.4,4.6z M11.4,4.6h8.2v2.7h-8.2V4.6z M25,26.4H6V7.4h2.7v2.7h13.6V7.4H25V26.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSurvey);
export default __webpack_public_path__ + "static/media/icon_survey.b8e0e12b0d4633a0c63484c231b61b67.svg";
export { ForwardRef as ReactComponent };